import styled from 'styled-components'

const SmartFunctionActionDropdownDropDownItem = styled.div`
  width: 200px;
`

export default SmartFunctionActionDropdownDropDownItem
